/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import { classiService } from '@/services';
import get from 'lodash/get';
import parseInt from 'lodash/parseInt';

export const state = {
  all: {},
  genitori: {},
  selectedClass: {},
  chat: {},
};

export const getters = {
  selectedClass: state => state.selectedClass,
  getRoomName: state => `${get(state, ['chat', 'items', 'room_name']) || ''}`,
  getParticipants: state => get(state, ['chat', 'items', 'participants']) || [],
  userId: state => get(state, ['chat', 'items']),
  roomId: state =>
    (get(state, ['chat', 'items', 'room', 'id'])
      ? parseInt(get(state, ['chat', 'items', 'room', 'id']))
      : null),
};

export const actions = {
  init({ state }) {
    state.all = {};
    state.genitori = {};
    state.selectedClass = {};
    state.chat = {};
  },
  async getClassi({ commit, dispatch }) {
    await classiService
      .getClassi()
      .then((response) => {
        commit('getAllSuccess', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  setSelectedClass({ commit, dispatch }, selectedClass) {
    commit('SET_SELECTED_CLASS', selectedClass);
    dispatch('setClassroom', selectedClass.id, { root: true });
    dispatch(
      'routerPush',
      {
        name: 'Insegnanti',
        query: { classe: selectedClass.class_name },
        params: { classeId: selectedClass.id },
      },
      {
        root: true,
      },
    );
  },
};

export const mutations = {
  getAllSuccess(state, classi) {
    state.all = {
      items: classi,
    };
  },
  getAllFailure(state, error) {
    state.all = {
      error,
    };
  },
  addAllSuccess(state, classi) {
    state.all = {
      items: classi,
    };
  },
  SET_SELECTED_CLASS(state, data) {
    state.selectedClass = data;
  },
};
